
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/.well-known/appspecific/com.chrome.devtools.json",
      function () {
        return require("private-next-pages/.well-known/appspecific/com.chrome.devtools.json/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/.well-known/appspecific/com.chrome.devtools.json"])
      });
    }
  